import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RadioButtonComponent } from '../../../interactive-labels/radio-button/radio-button.component';
import { ButtonComponent } from '../../../buttons/button/button.component';
import { ButtonType } from '../../../enum/button-type.enum';
import { TableFilter, TableFilterOption } from '../../models/table-filter';
import { InputSize } from '../../../enum/input-size.enum';

@Component({
  selector: 'lib-radio-filter',
  imports: [ButtonComponent, RadioButtonComponent],
  templateUrl: './radio-filter.component.html',
  styleUrl: './radio-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioFilterComponent {
  tableFilter = input.required<TableFilter>();

  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;

  radioOptionClicked(option: TableFilterOption) {
    this.unselectAllUnsavedOptions();
    option.isSelected?.set(true);
  }

  resetClicked() {
    this.tableFilter().resetUnsavedOptions();
  }

  private unselectAllUnsavedOptions() {
    this.tableFilter().unsavedOptions?.forEach(o => {
      o.isSelected?.set(false);
    });
  }
}
